import MediaNavTabs from '@/components/MediaNavTabs';
import React, { useEffect, useState } from 'react';
import { proceedingsAPI } from '@/services/proceedingsService';
import { getImageUrl } from '@/services/api';

const Proceeding = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await proceedingsAPI.listPublic();
        const all = res.data || [];
        setItems(all.filter((item) => item.category === 'proceedings'));
      } catch (e) {
        console.error('Error loading proceedings:', e);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleOpenPdf = (item) => {
    const pdfUrl = getImageUrl(item?.pdf_url);
    if (pdfUrl) window.open(pdfUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative mt-16 sm:mt-20">
        <div className="w-full py-10 sm:py-16" style={{ background: 'linear-gradient(90deg, #BFB4EE 0%, #B3FFD1 100%)' }}>
          <div className="max-w-7xl mx-auto px-4">
            <h1 className="text-center font-bold" style={{ color: '#533192', fontFamily: 'Prompt', fontSize: 'clamp(1.6rem, 5vw, 3rem)' }}>
              สื่อและข่าวสาร
            </h1>
          </div>
        </div>
        <MediaNavTabs />
        <div className="w-full h-1.5" style={{ background: '#533193' }} />
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8 sm:py-12">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-6 sm:mb-8" style={{ fontFamily: 'Prompt', color: '#333' }}>
          Proceeding
        </h2>

        {loading ? (
          <div className="h-48 flex items-center justify-center text-gray-500">กำลังโหลด...</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            {items.map((item) => (
              <div
                key={item.id}
                onClick={() => handleOpenPdf(item)}
                className="relative rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:scale-[1.02] hover:-translate-y-1 cursor-pointer"
              >
                <div className="absolute inset-0">
                  <img src={getImageUrl(item.image_url)} alt={item.title} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-purple-900/80" />
                </div>
                <div className="relative h-[280px] sm:h-[360px] md:h-[420px] flex flex-col justify-end p-4 sm:p-5 md:p-6">
                  <div className="space-y-2 sm:space-y-3">
                    <div className="flex flex-wrap gap-2">
                      <span className="text-xs border border-white/60 text-white px-3 py-1 rounded-full">Proceeding</span>
                    </div>
                    <h3 className="text-base sm:text-lg md:text-xl font-bold text-white line-clamp-2" style={{ fontFamily: 'Prompt' }}>
                      {item.title}
                    </h3>
                    <p className="text-white/80 text-xs sm:text-sm line-clamp-2" style={{ fontFamily: 'Prompt' }}>
                      {item.summary || `โดย: ${item.author || ''}`}
                    </p>
                    <div className="flex justify-end">
                      <span className="w-9 h-9 sm:w-11 sm:h-11 bg-purple-600 rounded-full flex items-center justify-center hover:bg-purple-700 transition-colors">
                        <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {items.length === 0 && (
              <div className="col-span-full py-14 text-center text-gray-500">ยังไม่มีข้อมูล Proceeding</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Proceeding;
